export type VpnImportApp = "v2raytun" | "happ";

export function buildVpnImportAppLink(app: VpnImportApp, configUrl: string) {
  const scheme = `${app}://`;

  if (configUrl.startsWith(scheme)) {
    return configUrl;
  }

  if (app === "happ") {
    return `happ://add/${configUrl}`;
  }

  return `v2raytun://import/${configUrl}`;
}
